<template>
  <div
    class="questions-card"
    :class="{'pointer': !showButton}"
    data-qa="questions-card"
    @click="showButton ? null : $emit('openChat', item.particpantOrganizationId)">
    <sBadge
      class="width-100 questions-card-org-title"
      color="red"
      :content="needDot"
      data-qa="question-card-badge"
      dot
      overlap
      :value="needDot">
      {{ item.particpantOrganizationTitle }}
    </sBadge>
    <div
      class="questions-card-date"
      data-qa="questions-card-date">
      {{ $d(item.lastDateQuestion, 'longDate') }}
    </div>
    <div
      class="questions-card-message"
      data-qa="questions-card-message">
      {{ lastChild.message }}
    </div>
    <template
      v-if="lastChild.attachments && lastChild.attachments.length > 0">
      <div
        v-for="(attachment, attachmentIndex) in lastChild.attachments"
        :key="`${lastChild.questionId}-file-${attachmentIndex}`"
        class="questions-card-attachment"
        data-qa="questions-card-attachment">
        <sIcon
          :data-qa="`${lastChild.questionId}-file-icon-${attachmentIndex}`"
          type="draft"/>
        <span
          class="questions-card-attachment-title"
          :data-qa="`${lastChild.questionId}-file-title-${attachmentIndex}`">{{ attachment.title }}</span>
      </div>
    </template>
    <div
      v-if="showButton"
      class="text-right">
      <sButton
        data-qa="questions-card-button"
        small
        type="text"
        @click="$emit('openChat', item.particpantOrganizationId)">
        {{ $t('Common.OpenChat') }}
      </sButton>
    </div>
  </div>
</template>
<script>
/**
 * Карточка организации участника в чатах
 */
export default {
  name: 'questionCard',
  data() {
    return {
      needDot: false
    }
  },
  props: {
    item: {
      type: Object,
      require: true
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    lastChild() {
      if (!this.item?.questions?.length) {
        return null
      }
      return this.item.questions[this.item.questions.length - 1]
    }
  },
  created() {
    // TODO: будет признак просмотра, тогда включим
    //this.needDot = !!this.item.questions.find(i => !i.answers?.length)
  },
}
</script>
<style scoped>
.questions-card-attachment {
  display: flex;
  margin-top: 10px;
  height: 20px;
}
.questions-card-attachment-title {
  text-transform: capitalize;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  margin-left: 5px;
  line-height: 1;
}
.questions-card {
  padding: 10px 10px 10px 20px;
  text-align: left;
  background: var(--v-secondary__green_chosen-base);
  border-radius: 8px;
  margin-bottom: 10px;
  font-weight: 500;
}
.questions-card-org-title {
  font-weight: 600;
  line-height: 18px;
  text-decoration: underline;
}
.questions-card-date {
  font-size: 12px;
  line-height: 16px;
  opacity: 0.5;
}
.questions-card-message {
  white-space: pre-line;
  margin-top: 4px;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 5px;
  max-height: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}
</style>
